import { RadioGroup, RadioLabel } from './radio-group/RadioGroup'
import { RadioEndContent, RadioItemPublic, RadioStartContent } from './radio-item/RadioItem'

export const Radio = {
  Group: RadioGroup,
  GroupLabel: RadioLabel,
  Item: RadioItemPublic,
  StartContent: RadioStartContent,
  EndContent: RadioEndContent,
}
